import { useRef } from "react";
import { t, font } from "@realtyflows/ui";

export default function CodeInput({ value = "", onChange, length = 6, disabled = false }) {
  const inputs = useRef([]);
  const digits = value.padEnd(length, " ").split("").slice(0, length);

  const handleChange = (index, char) => {
    if (!/^\d?$/.test(char)) return;
    const newDigits = [...digits];
    newDigits[index] = char;
    onChange(newDigits.join("").trim());
    if (char && index < length - 1) {
      inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
    if (pasted.length > 0) {
      e.preventDefault();
      onChange(pasted);
      inputs.current[Math.min(pasted.length, length - 1)]?.focus();
    }
  };

  return (
    <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={el => inputs.current[i] = el}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={d === " " ? "" : d}
          disabled={disabled}
          onChange={e => handleChange(i, e.target.value)}
          onKeyDown={e => handleKeyDown(i, e)}
          onPaste={i === 0 ? handlePaste : undefined}
          onFocus={e => e.target.select()}
          style={{
            width: 44, height: 52, textAlign: "center",
            fontSize: 20, fontWeight: 700, fontFamily: font.mono,
            background: t.surfaceWarm, border: `1.5px solid ${t.border}`, borderRadius: 8,
            color: t.textPrimary, outline: "none",
            transition: "border-color 0.15s",
          }}
          onFocusCapture={e => e.target.style.borderColor = t.emerald}
          onBlurCapture={e => e.target.style.borderColor = t.border}
        />
      ))}
    </div>
  );
}
